/* eslint-disable eqeqeq */
import React from "react";
import { Image } from "src/components";

import WZU from "src/assets/images/notimage.png";

import DIR from "src/assets/images/dir.png";
import MEN from "src/assets/images/mle.png";
import CRR from "src/assets/images/crr.png";
import MGL from "src/assets/images/mga_new.png";
import MDA from "src/assets/images/mda.png";
import SPX from "src/assets/images/spx.png";
import MFL from "src/assets/images/mfu.png";
import EVI from "src/assets/images/evi.png";
import AMZ from "src/assets/images/amz.png";
import MGF from "src/assets/images/mgf.png";
import MGE from "src/assets/images/mga.png";
import MLX from "src/assets/images/mlx.png";
import MLT from "src/assets/images/mlt.png";
import AME from "src/assets/images/ame.png";
import SHN from "src/assets/images/shn.png";
import SHD from "src/assets/images/shd.png";
import MGN from "src/assets/images/mgn.png";
import SHO from "src/assets/images/sho.png";
import TJT from "src/assets/images/tjt.png";
import TIK from "src/assets/images/tik.png";
import MLB from "src/assets/images/mlb.png";

function PlatformShippingIcon({ platform, width, height, style = {} }) {
  return (
    <Image
      style={{
        width,
        height,
        borderRadius: 5,
        ...style
      }}
      src={
        platform == 1
          ? CRR // Correios
          : platform === 2
          ? DIR // B2W Entregas (Direct)
          : platform === 3
          ? MEN // Mercado Livre (Coletas)
          : platform == 4
          ? MGL // Magazine Luiza (MagaLog)
          : platform == 5
          ? MDA // Mandaê
          : platform == 6
          ? MFL // Mercado Livre (Full)
          : platform == 7
          ? SPX // Shopee Xpress
          : platform == 8
          ? CRR // Shopee (Correios)
          : platform == 9
          ? WZU // Envio Fullfillment
          : platform == 11
          ? EVI // Envvias7
          : platform == 12
          ? MGF // Envio Fullfillment
          : platform == 15
          ? AMZ // Envio Fullfillment
          : platform == 16
          ? AMZ // Envio Fullfillment
          : platform == 19
          ? MGE // Envio Magalu Entregas
          : platform == 20
          ? MEN // Envio MErcado Livre Entregas
          : platform == 21
          ? MLB // MELI Combinar Entrega
          : platform == 22
          ? MLX // Envio Mercado Livre Flex
          : platform == 23
          ? MLT // Envio Mercado Livre Turbo
          : platform == 24
          ? MGE // Envio Magalu Entregas
          : platform == 25
          ? AME // Americanas Entrega 
          : platform == 26
          ? SHN // Shein Entregas
          : platform == 27
          ? SHD // Shopee Entrega Direta
          : platform == 28
          ? MGE // Envio Magalu Entregas
          : platform == 30
          ? MGN // MagaLu Entregas NetShoes
          : platform == 31
          ? SHO // Shopee
          : platform == 32
          ? SHO // Envio Magalu Entregas
          : platform == 34
          ? CRR // Envio TikTok Correios
          : platform == 35
          ? TIK // Envio TikTok Fullfillment
          : platform == 36
          ? TJT // Envio TikTok JIT
          : WZU
      }
      alt={platform}
    />
  );
}

export default PlatformShippingIcon;
